import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { BRAND_FULL_NAME } from '../../config/brand';
import { useAuth } from '../../contexts/AuthContext';
import HomeSectionFrame from './HomeSectionFrame';

const HomeCtaBanner: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  return (
    <HomeSectionFrame id="final-cta" aria-labelledby="final-cta-heading" tone="ink" className="pb-8 sm:pb-10">
      <div className="relative z-[1] flex max-w-2xl flex-col items-start gap-4">
        <h2
          id="final-cta-heading"
          className="relative m-0 max-w-[20ch] text-[clamp(1.35rem,2.2vw+0.8rem,2.15rem)] font-extrabold leading-[1.45] text-white"
        >
          جاهز تبدأ رحلتك مع {BRAND_FULL_NAME}؟
        </h2>
        <p className="relative max-w-[40ch] text-sm leading-relaxed text-white/80 sm:text-base sm:leading-7">
          سجّل حسابك، اختار صفّك، وابدأ تتصفّح الكورسات اللي تناسبك.
        </p>
        <div className="relative mt-2 flex w-full flex-col gap-3 min-[480px]:w-auto min-[480px]:flex-row min-[480px]:flex-wrap">
          {mounted && (
            <button
              type="button"
              onClick={() => navigate(isAuthenticated ? '/student-portal' : '/register')}
              className="inline-flex min-h-[60px] w-full items-center justify-center gap-2.5 rounded-[18px] border-2 border-white bg-white px-7 py-3.5 text-base font-bold text-slate-900 transition hover:bg-brand-50 min-[480px]:w-auto"
            >
              <span>{isAuthenticated ? 'ادخل لمنصتك' : 'أنشئ حسابك الآن'}</span>
              <ArrowLeft className="h-[22px] w-[22px]" aria-hidden />
            </button>
          )}
          <button
            type="button"
            onClick={() =>
              document.getElementById('grades-section')?.scrollIntoView({ behavior: 'smooth' })
            }
            className="inline-flex min-h-[60px] w-full items-center justify-center gap-2.5 rounded-[18px] border-2 border-white/55 bg-transparent px-7 py-3.5 text-base font-bold text-white transition hover:border-white hover:bg-white/10 min-[480px]:w-auto"
          >
            تصفح الكورسات
          </button>
        </div>
      </div>
    </HomeSectionFrame>
  );
};

export default HomeCtaBanner;
